/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="controls.module.ts" />

module Meevo.Components.Controls {
    'use strict';

    enum AlignmentEnum {
        Left = 11045214,
        Center = 11045215,
        Right = 11045216
    }

    interface IScope extends ng.IScope {
        color: string,
        size: number,
        alignment: AlignmentEnum,
        disabled: boolean,
        changed: Function,
        onClick: Function
    }

    export class FontStyleButtonsDirective implements angular.IDirective {
        restrict = 'E';
        templateUrl = "app/components/controls/fontCustomizationTemplate.html";
        scope = {
            color: '=',
            size: '=',
            alignment: '=',
            vertalignment: '=',
            changed: '&',
            disabled: '=ngDisabled'
        };

        constructor(private $rootScope) {
            
        }

        link = (scope: IScope, element: JQuery) => {
            if (!scope.color)
                scope.color = "#000000";

            /**
             * Alignment click handler
             * */
            scope.onClick = (alignment: number): void => {
                scope.alignment = alignment;
                setTimeout(() => {
                    scope.changed();
                    this.$rootScope.$digest();
                }, 0);
            }

            scope.changeVerticalAlignment = (alignment: number): void => {
                scope.vertalignment = alignment;
                setTimeout(() => {
                    scope.changed();
                    this.$rootScope.$digest();
                }, 0);
            }
        };

        static factory(): angular.IDirectiveFactory {
            let directive = ($rootScope) => {
                return new FontStyleButtonsDirective($rootScope);
            };
            directive.$inject = ["$rootScope"]
            return directive;
        }
    }
    angular.module('meevo.components.controls')
        .directive('fontCustomization', FontStyleButtonsDirective.factory());
}
